import axiosInstance from "./axios";

export class LibroService {
    /**
     * Obtiene la lista de libros
     */
    getLibros() {
        return axiosInstance
            .get(`/libro`)
            .then((res) => res.data)
    }

    /**
     * Agrega un nuevo libro
     * @param {Object} dto
     */
    addLibro(dto) {
        return axiosInstance
            .post(`/libro`, dto)
            .then((res) => res.data)
    }

    /**
     * Actualiza un libro existente
     * @param {Object} dto
     */
    updateLibro(dto) {
        return axiosInstance
            .put(`/libro/${dto._id}`, dto)
            .then((res) => res.data)
    }

    /**
     * Elimina un libro
     * @param {string} id
     */
    deleteLibro(id) {
        return axiosInstance
            .delete(`/libro/${id}`)
            .then((res) => res.data)
    }
}
